/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterVolumeSpecification } from './emrClusterVolumeSpecification';


export interface EmrClusterEbsBlockDevice { 
    volumeSpecification?: EmrClusterVolumeSpecification;
    /**
     * The device name that is exposed to the instance, such as /dev/sdh.                
     */
    device?: string;
    /**
     * Number of EBS volumes with a specific volume configuration that will be associated with every instance in the instance group                
     */
    volumesPerInstance?: number;
}
